import React from 'react'

import { usePlaceTypesWithPermission } from '../../../utils/helpers/placeTypes'
import FilterSideModal from '../../../components/filter/FilterSideModal'
import PlacesFilterGroupItems from './PlacesFilterGroupItems'

const FullPlacesFilterSideModal = ({ label, ...props }) => {
  label = label || 'Locais'
  const types = usePlaceTypesWithPermission('list')

  return (
    <FilterSideModal
      label={label}
      {...props}
      renderOptions={() =>
        types.map(type => <PlacesFilterGroupItems key={type.key} label={type.name} type={type.key} {...props} />)
      }
    ></FilterSideModal>
  )
}

export default FullPlacesFilterSideModal
